import { watch } from 'vue'
import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import de from './locales/de.json'
import es from './locales/es.json'
import fr from './locales/fr.json'
import it from './locales/it.json'
import nl from './locales/nl.json'

export type SupportedLocale = 'en' | 'de' | 'es' | 'fr' | 'it' | 'nl'

export const SUPPORTED_LOCALES: { code: SupportedLocale; label: string; flag: string }[] = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'nl', label: 'Nederlands', flag: '🇳🇱' }
]

function getStoredLocale(): SupportedLocale {
  const stored = localStorage.getItem('locale')
  if (stored && ['en', 'de', 'es', 'fr', 'it', 'nl'].includes(stored)) {
    return stored as SupportedLocale
  }
  // Detect browser language
  const browserLang = navigator.language.split('-')[0]
  if (['en', 'de', 'es', 'fr', 'it', 'nl'].includes(browserLang)) {
    return browserLang as SupportedLocale
  }
  return 'en'
}

const i18n = createI18n({
  legacy: false,
  locale: getStoredLocale(),
  fallbackLocale: 'en',
  messages: { en, de, es, fr, it, nl }
})

watch(i18n.global.locale, locale => {
  document.documentElement.lang = locale
}, { immediate: true, flush: 'sync' })

export default i18n
